import { Box, Button, MenuItem, Select, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { getUserType } from "util/auth";
import MenuPriceSetting from "components/menu/MenuPriceSetting";
import useLoadMore from "hooks/useLoadMore";
import LabelHeader from "components/Label/LabelHeader";
import WheelPriceTable from "../components/WheelPriceTable";
import useWheelPriceSetting from "../hooks/useWheelPriceSetting";
import { PRICE_SETTING_TIRE } from "../../proc_fee/types/tire";

/**
 * WheelPriceSetting component for various store-specific settings.
 */
export default function WheelPriceSetting() {
  const navigate = useNavigate();
  const { wheelPriceTable, handleUpdatePrice, onLoadMore, loading, storePriceSetting, handleStorePriceSettingChange } = useWheelPriceSetting();
  const { renderNodeLoader } = useLoadMore(onLoadMore, loading);
  return (
    <>
      <Box sx={{ px: { xs: 2, md: 2.5, lg: 4, xl: 7 }, pt: { xs: 2, md: 2.5, lg: 3 } }}>
        <Button onClick={() => navigate("/")} variant="custom-outlined">
          <Box>＜ 戻る</Box>
        </Button>
      </Box>
      <Box
        sx={{ display: "flex", gap: 3, flexWrap: "wrap", padding: { xs: 2, md: 2.5, lg: 4, xl: 7 } }}
      >
      <Box
        sx={{
          display: { xs: "flex", xl: "block" },
          justifyContent: "space-between",
          flexBasis: { xs: "100%", xl: "290px" },
        }}
      >
        <Typography
          variant="h5"
          margin={0}
          textAlign="left"
          fontSize={{ xs: 24, md: 28, lg: 23 }}
          marginBottom="50px"
          color="var(--gray-600)"
        >
          <span style={{ fontSize: "33px" }}>マスタ管理</span> <br />
          <span style={{ fontSize: "28px" }}>売価設定</span> <br />
          <span style={{ fontSize: "28px" }}>ホイール</span>
        </Typography>
        <MenuPriceSetting />
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          flex: 1,
          width: { xs: "100%", lg: "auto" },
        }}
      >
        <Box sx={{ width: { xs: "100%", lg: "auto", ml: { xs: 3, lg: 0 } } }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: { xs: 4, xl: 7 },
            }}
          >
            <Box sx={{ width: { xs: "50%", md: "auto" } }}>
              <Typography
                sx={{ fontSize: { xs: 18, xl: 25 } }}
                variant="h5"
                color="var(--gray-600)"
                fontWeight="medium"
                marginBottom="12px"
              >
                ホイール売価設定
              </Typography>
              <Typography
                variant="h2"
                color="var(--black)"
                fontWeight="regular"
                sx={{ fontSize: { xs: 20, md: 24, xl: 35 } }}
              >
                ホイールの売価設定を行います
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
                flexWrap: "wrap",
                gap: 1,
                width: { xs: "50%", md: "auto" },
              }}
            >
              <LabelHeader
                sxBox={{
                  height: { xs: 32, lg: 48 },
                  display: "flex",
                  justifyContent: "center",
                  width: { xs: 280, lg: 340 },
                }}
                label="ホイールセット時の売価計算方法"
              />
              <Select
                sx={{
                  width: { xs: 150, md: 180, xl: 230 },
                  height: { xs: 32, lg: 48 },
                  fontSize: { xs: "16px", md: "18px", xl: "20px" },
                  color: "var(--gray-700)",
                  "& .MuiSelect-select": {
                    padding: "0 16px",
                    display: "flex",
                    alignItems: "center",
                  },
                }}
                value={storePriceSetting}
                onChange={(event) => handleStorePriceSettingChange(Number(event.target.value))}
              >
                <MenuItem value={PRICE_SETTING_TIRE.SELLING}>売価から計算</MenuItem>
                <MenuItem value={PRICE_SETTING_TIRE.COST}>原価から計算</MenuItem>
              </Select>
            </Box>
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              marginBottom: "12px",
            }}
          >
            <Box sx={{ textAlign: "right", display: "flex", alignItems: "center" }}>
              <Typography
                variant="h6"
                sx={{
                  color: "var(--black)",
                  fontSize: { xs: 16, md: 18, lg: 20 },
                  fontWeight: "bold",
                  marginRight: "20px",
                }}
              >
                {getUserType() === "C0002" ? "黒字：本部/企業設定" : "黒字：本部設定"}
              </Typography>
              <Typography
                variant="h6"
                sx={{
                  color: "var(--red-800)",
                  fontSize: { xs: 16, md: 18, lg: 20 },
                  fontWeight: "bold",
                  marginRight: "15px",
                }}
              >
                赤字：{getUserType() === "C0006" ? "企業上書設定" : "店舗上書設定"}
              </Typography>
            </Box>
          </Box>
          <Box sx={{ overflowX: "auto", width: "100%" }}>
            <WheelPriceTable
              wheelPriceTable={wheelPriceTable}
              onUpdatePrice={handleUpdatePrice}
              storePriceSetting={storePriceSetting}
            />
            {renderNodeLoader()}
          </Box>
        </Box>
      </Box>
    </Box>
    </>
  );
}
